<template>
  <div
    class="prices-list-card d-flex flex-column"
    :class="{ 'ga-4': isMobile }"
  >
    <div
      class="prices-list-card__body"
      :class="borderless
        ? undefined
        : ['rounded-24', 'border-sm', isMobile ? 'pa-2' : 'pa-4']"
      :data-qa="listQa"
    >
      <slot />
      <div
        v-if="showAllHref && !isMobile"
        class="d-flex justify-center mt-2"
      >
        <PricesShowAllLink
          :href="showAllHref"
          :data-qa="moreQa"
        />
      </div>
    </div>
    <PricesShowAllLink
      v-if="showAllHref && isMobile"
      :href="showAllHref"
      :data-qa="moreQa"
    />
  </div>
</template>

<script lang="ts" setup>
import useIsMobile from 'src/composables/useIsMobile'
import PricesShowAllLink from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesShowAllLink.vue'

defineProps<{
  showAllHref?: string
  listQa?: string
  moreQa?: string
  /** Без обводки и внешнего padding — как у zebra-рядов без карточки. */
  borderless?: boolean
}>()

const isMobile = useIsMobile()
</script>

<style scoped lang="scss">
.prices-list-card {
  width: 100%;
  min-width: 0;
  max-width: 100%;

  &__body {
    min-width: 0;
    max-width: 100%;
  }
}
</style>
